import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
  faComments,
  faLocationDot,
} from '@fortawesome/free-solid-svg-icons';

export default function Contact() {
  const [form, setForm] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!form.name || !form.email || !form.message) {
      return toast.error('Please fill all fields');
    }

    toast.success('Message sent successfully!');
    setForm({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <section id="contact" style={s.section}>

      {/* Header */}
      <div style={s.header}>
        <h2 style={s.title}>
          Get in <span style={s.gradient}>Touch</span>
        </h2>
        <p style={s.sub}>
          Have questions or need a custom solution? We’d love to hear from you.
        </p>
      </div>

      <div style={s.container}>

        {/* LEFT CARDS */}
        <div style={s.left}>

          <div style={s.contactCard}>
            <div style={s.icon}><FontAwesomeIcon icon={faEnvelope} /></div>
            <div>
              <div style={s.cardTitle}>Email Us</div>
              <div style={s.cardDesc}>support@datasphere.io</div>
              <div style={s.cardSub}>We respond within 24 hours</div>
            </div>
          </div>

          <div style={s.contactCard}>
            <div style={s.icon}><FontAwesomeIcon icon={faComments} /></div>
            <div>
              <div style={s.cardTitle}>Live Chat</div>
              <div style={s.cardDesc}>Available Mon–Fri, 9am–6pm</div>
              <div style={s.cardSub}>Talk to our team in real-time</div>
            </div>
          </div>

          <div style={s.contactCard}>
            <div style={s.icon}><FontAwesomeIcon icon={faLocationDot} /></div>
            <div>
              <div style={s.cardTitle}>Office</div>
              <div style={s.cardDesc}>Noida • Uttar Pradesh • India</div>
              <div style={s.cardSub}>Schedule a visit or demo</div>
            </div>
          </div>

        </div>

        {/* RIGHT FORM */}
        <form onSubmit={handleSubmit} style={s.form}>

          <div style={s.row}>
            <div style={s.field}>
              <label style={s.label}>Name</label>
              <input
                style={s.input}
                placeholder="Enter Your Name"
                value={form.name}
                onChange={(e) => set('name', e.target.value)}
              />
            </div>

            <div style={s.field}>
              <label style={s.label}>Email</label>
              <input
                style={s.input}
                placeholder="Enter Your Email"
                value={form.email}
                onChange={(e) => set('email', e.target.value)}
              />
            </div>
          </div>

          <div style={s.field}>
            <label style={s.label}>Subject</label>
            <input
              style={s.input}
              placeholder="Enter Your Subject"
              value={form.subject}
              onChange={(e) => set('subject', e.target.value)}
            />
          </div>

          <div style={s.field}>
            <label style={s.label}>Message</label>
            <textarea
              style={s.textarea}
              placeholder="Tell us about your use case..."
              value={form.message}
              onChange={(e) => set('message', e.target.value)}
            />
          </div>

          <button type="submit" style={s.button}>
            Send Message →
          </button>

          <div style={s.note}>
            We respect your privacy. No spam, ever.
          </div>

        </form>
      </div>
    </section>
  );
}
const s = {
  section: {
    padding: '90px 80px',
    background:'linear-gradient(135deg,#eef2ff,#f8fafc)'
  },

  header: {
    textAlign: 'center',
    marginBottom: 60,
  },

  title: {
    fontSize: 36,
    fontWeight: 800,
    marginBottom: 10,
  },

  gradient: {
    background: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },

  sub: {
    color: 'var(--text-muted)',
    fontSize: 15,
  },

  container: {
    display: 'flex',
    gap: 40,
  },

  left: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
  },

  contactCard: {
    display: 'flex',
    gap: 16,
    padding: 20,
    borderRadius: 16,
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.05)',
    boxShadow: '0 10px 30px rgba(0,0,0,0.04)',
  },

  icon: {
    width: 46,
    height: 46,
    borderRadius: 12,
    background: 'rgba(99,102,241,0.12)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6366f1',
    fontSize: 18,
  },

  cardTitle: {
    fontWeight: 700,
    marginBottom: 4,
  },

  cardDesc: {
    fontSize: 14,
  },

  cardSub: {
    fontSize: 12,
    color: 'var(--text-muted)',
  },

  form: {
    flex: 1.2,
    padding: 28,
    borderRadius: 18,
    background: '#fff',
    boxShadow: '0 15px 40px rgba(0,0,0,0.06)',
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },

  row: {
    display: 'flex',
    gap: 16,
  },

  field: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },

  label: {
    fontSize: 13,
    fontWeight: 500,
  },

  input: {
    padding: '12px 14px',
    borderRadius: 10,
    border: '1px solid var(--border)',
    fontSize: 14,
  },

  textarea: {
    padding: '12px 14px',
    borderRadius: 10,
    border: '1px solid var(--border)',
    minHeight: 120,
    resize: 'none',
  },

  button: {
    marginTop: 10,
    padding: '14px',
    borderRadius: 12,
    background: 'linear-gradient(135deg,#4f46e5,#6366f1)',
    color: '#fff',
    border: 'none',
    fontWeight: 600,
    cursor: 'pointer',
  },

  note: {
    fontSize: 12,
    color: 'var(--text-muted)',
    textAlign: 'center',
    marginTop: 6,
  },
};